var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.2532 3 12.4892 3.12769 12.6278 3.33956L16.4877 9.24306L21.8721 6.10217C22.1277 5.9531 22.447 5.96818 22.6873 6.14066C22.9277 6.31315 23.0442 6.61081 22.9848 6.90062L20.9138 17.0031C20.5561 18.7476 19.0209 20 17.2401 20H6.75992C4.97914 20 3.44395 18.7476 3.08632 17.0031L1.01531 6.90062C0.955898 6.61081 1.0724 6.31315 1.31275 6.14067C1.55311 5.96818 1.87239 5.9531 2.12793 6.10217L7.51232 9.24306L11.3723 3.33956C11.5108 3.12769 11.7469 3 12 3ZM12 5.12049L8.37776 10.6604C8.15921 10.9947 7.71708 11.0991 7.37213 10.8978L2.82179 8.24347L4.55576 16.7019C4.77033 17.7486 5.69144 18.5 6.75992 18.5H17.2401C18.3086 18.5 19.2297 17.7486 19.4443 16.7019L21.1783 8.24347L16.6279 10.8978C16.283 11.0991 15.8408 10.9947 15.6223 10.6604L12 5.12049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.3487e0e3633257619f4df525128db4fd.svg";
export { ForwardRef as ReactComponent };